export default {
    en: {
        DATETIMEPICKER_CLEAR: 'Clear',
        DATETIMEPICKER_CANCEL: 'Cancel',
        DATETIMEPICKER_CONFIRM: 'Confirm'
    }
};
